export { default } from './ClientDetailsFlyout';
